import Vue from 'vue'
import Router from 'vue-router'

import Main from '../Main.vue'
import Home from '../components/home/Home.vue'
import Login from '../Login.vue'

//员工合同---------------------------------------------------------
import HtmbGl from '../components/ygdagl/HtmbGl/HtmbGl.vue'
import HtmbSh from '../components/ygdagl/HtmbSH/HtmbSh.vue'
import HtqdFq from '../components/ygdagl/HtqdFQ/HtqdFq.vue'
import Htqd from '../components/ygdagl/HtQd/Htqd.vue'
import Htgd from '../components/ygdagl/HtGd/Htgd.vue'
import Ygdaxx from '../components/ygdagl/YgdaXx/Ygdaxx.vue'
import Jfmtgl from '../components/ygdagl/JfmtGl/Jfmtgl.vue'
import Xmht from '../components/ygdagl/Xmht/Xmht.vue'
//----------------------------------------------------------------


//基础人事---------------------------------------------------------
import Jtzzjg from '../components/jcrsgl/Jtzzjggl/Jtzzjggl.vue'
import Ygxxlb from '../components/jcrsgl/Ygxxlb/Ygxxlb.vue'
import Ygrz from '../components/jcrsgl/Ygrz/Ygrz.vue'
import Yghtqd from '../components/jcrsgl/Yghtqd/Yghtqd.vue'
import Ygzz from '../components/jcrsgl/Ygzz/Ygzz.vue'
import Yglz from '../components/jcrsgl/Yglz/Yglz.vue'
import Ygtg from '../components/jcrsgl/Ygtg/Ygtg.vue'
import Hmdgl from '../components/jcrsgl/Hmdgl/Hmdgl.vue'
import Wcsq from '../components/jcrsgl/Wcsq/Wcsq.vue'
import Qjsq from '../components/jcrsgl/Qjsq/Qjsq.vue'
import Ccsq from '../components/jcrsgl/Ccsq/Ccsq.vue'
import Bksq from '../components/jcrsgl/Bksq/Bksq.vue'
import Jbsq from '../components/jcrsgl/Jbsq/Jbsq.vue'
//岗位支援管理
import Gwzysq from '../components/jcrsgl/Gwzygl/Gwzysq/Gwzysq.vue'
import Gwzy from '../components/jcrsgl/Gwzygl/Gwzy/Gwzy.vue'
import Gwzyjs from '../components/jcrsgl/Gwzygl/Gwzyjs/Gwzyjs.vue'

import Dgsq from '../components/jcrsgl/Dgsq/Dgsq.vue'
import Jcgl from '../components/jcrsgl/Jcgl/Jcgl.vue'
import Zttx from '../components/jcrsgl/Zttx/Zttx.vue'
import QAsp from '../components/jcrsgl/QAsp/QAsp.vue'
import Bxjsgl from '../components/jcrsgl/Bxjsgl/Bxjsgl.vue'
//----------------------------------------------------------------


// 保险管理---------------------------------------------------------
import Gzxgl from '../components/bxgl/GzxGl/Gzxgl.vue'
import Gzxbfgl from '../components/bxgl/GzxbfGl/Gzxbfgl.vue'
import Gzxcx from '../components/bxgl/GzxCx/Gzxcx.vue'
import Qtxzgl from '../components/bxgl/QtxzGl/Qtxzgl.vue'
import Qtxzcx from '../components/bxgl/QtxzCx/Qtxzcx.vue'
import Unpaid from '../components/bxgl/Unpaid/Unpaid.vue'
//----------------------------------------------------------------

//智能排班--------------------------------------------------------
import KqzGl from '../components/znpb/KqzGl/KqzGl.vue'
import QyxmGl from '../components/znpb/QyxmGl/QyxmGl.vue'
import YdgzrSd from '../components/znpb/YdgzrSd/YdgzrSd.vue'
import ZnPb from '../components/znpb/ZnPb/ZnPb.vue'
//---------------------------------------------------------------

//考勤管理---------------------------------------------------------
import KqHz from '../components/kqgl/KqHz/KqHz.vue'
import dkmx from '../components/kqgl/dkmx/dkmx.vue'
import dkzp from '../components/kqgl/dkzp/dkzp.vue'
//----------------------------------------------------------------

//行政管理---------------------------------------------------------
import SsfjGl from '../components/xzgl/SsfjGl/SsfjGl.vue'
import SsrzGl from '../components/xzgl/SsrzGl/SsrzGl.vue'
import SstzGl from '../components/xzgl/SstzGl/SstzGl.vue'
import WpGl from '../components/xzgl/WpGl/WpGl.vue'
import WpjcGl from '../components/xzgl/WpjcGl/WpjcGl.vue'
import WpghGl from '../components/xzgl/WpghGl/WpghGl.vue'
import WpzhCx from '../components/xzgl/WpzhCx/WpzhCx.vue'
//----------------------------------------------------------------

//投标管理---------------------------------------------------------
import Bond from '../components/tender/Bond/Bond.vue'
import Performance from '../components/tender/Performance/Performance.vue'
import Gather from '../components/tender/Gather/Gather.vue'
import Agreement from '../components/tender/Agreement/Agreement.vue'
//----------------------------------------------------------------

//应收账款管理---------------------------------------------------------
import Receivable from '../components/receivable/Receivable/Receivable.vue'
import Collection from '../components/receivable/Collection/Collection.vue'
import Invoicebill from '../components/receivable/Invoicebill/Invoicebill.vue'
import DetailspartyA from '../components/receivable/DetailspartyA/DetailspartyA.vue'
import DetailsparB from '../components/receivable/DetailsparB/DetailsparB.vue'
import Collectiondata from '../components/receivable/Collectiondata/Collectiondata.vue'
import Cleaning from '../components/receivable/Cleaning/Cleaning.vue'
import Securitystaff from '../components/receivable/Securitystaff/Securitystaff.vue'


//----------------------------------------------------------------

//预算管理---------------------------------------------------------
import Budgeting from '../components/budget/Budgeting/Budgeting.vue'
import Summary from '../components/budget/Summary/Summary.vue'
import Budmanagement from '../components/budget/Budmanagement/Budmanagement.vue'
import Implementation from '../components/budget/Implementation/Implementation.vue'
import Budsplitting from '../components/budget/Budsplitting/Budsplitting.vue'
//----------------------------------------------------------------

//进场测算管理---------------------------------------------------------
import Mobilization from '../components/Mobilization/Mobilization.vue'
//----------------------------------------------------------------

//OA管理---------------------------------------------------------
import approve from '../components/oa/approve/approve.vue'
import set from '../components/oa/set/set.vue'
//----------------------------------------------------------------

//工资核算管理---------------------------------------------------------
import GzMx from '../components/gzhsgl/GzMx/GzMx.vue'
import GzZb from '../components/gzhsgl/GzZb/GzZb.vue'
import GzHz from '../components/gzhsgl/GzHz/GzHz.vue'
import GzffHz from '../components/gzhsgl/GzffHz/GzffHz.vue'
import GzcfHz from '../components/gzhsgl/GzcfHz/GzcfHz.vue'
import GzcfMx from '../components/gzhsgl/GzcfMx/GzcfMx.vue'
import FfblSz from '../components/gzhsgl/FfblSz/FfblSz.vue'
import GzmxBc from '../components/gzhsgl/GzmxBc/GzmxBc.vue'
import Jsfs from '../components/gzhsgl/Jsfs/Jsfs.vue'
//----------------------------------------------------------------


// 数据字典---------------------------------------------------------
import first_degree from '../components/dictionary/first_degree.vue'
import second_degree from '../components/dictionary/second_degree.vue'
import entry_type from '../components/dictionary/entry_type.vue'
import recruitment_method from '../components/dictionary/recruitment_method.vue'
import health from '../components/dictionary/health.vue'
import household_register from '../components/dictionary/household_register.vue'
import staff_type from '../components/dictionary/staff_type.vue'
import insurance_type from '../components/dictionary/insurance_type.vue'
import underwriting_type from '../components/dictionary/underwriting_type.vue'
import room_type from '../components/dictionary/room_type.vue'
import article_type from '../components/dictionary/article_type.vue'
import province from '../components/dictionary/province.vue'
import cities from '../components/dictionary/cities.vue'
import bank from '../components/dictionary/bank.vue'
import resignation_reason from '../components/dictionary/resignation_reason.vue'
import leave_type from '../components/dictionary/leave_type.vue'
import errand_type from '../components/dictionary/errand_type.vue'
import contract_type from '../components/dictionary/contract_type.vue'
import bonus_penalty from '../components/dictionary/bonus_penalty.vue'
import change_salary from '../components/dictionary/change_salary.vue'
import age_group from '../components/dictionary/age_group.vue'
import traffic_vehicle from '../components/dictionary/traffic_vehicle.vue'
import agency_company from '../components/dictionary/agency_company.vue'
import split_account from '../components/dictionary/split_account.vue'
import business_sector from '../components/dictionary/business_sector.vue'
import business_series from '../components/dictionary/business_series.vue'
import material from '../components/dictionary/material.vue'
import fixedassets from '../components/dictionary/fixedassets.vue'
import integration from '../components/dictionary/integration.vue'

//----------------------------------------------------------------


//系统管理---------------------------------------------------------
import user from '../components/system/user/User.vue'
import role from '../components/system/role/Role.vue'
import post from '../components/system/post/Post.vue'
import flow from '../components/system/flow/Flow.vue'
import setter from '../components/system/setter/setter.vue'
//----------------------------------------------------------------

//报表中心---------------------------------------------------------
import entry_exit from '../components/report/entry_exit.vue'
import employee_info from '../components/report/employee_info.vue'
import five_insurances_statistical from '../components/report/five_insurances_statistical.vue'
import five_insurances_detailed from '../components/report/five_insurances_detailed.vue'
import employer_insurance from '../components/report/employer_insurance.vue'
import electric_vehicle_insurance from '../components/report/electric_vehicle_insurance.vue'
import project_address_book from '../components/report/project_address_book.vue'
import project_natural_conditions from '../components/report/project_natural_conditions.vue'
import project_assessment from '../components/report/project_assessment.vue'
import big_ranking from '../components/report/big_ranking.vue'
import employer_insurance_statistical from '../components/report/employer_insurance_statistical.vue'
import budget_comparison_table from '../components/report/budget_comparison_table.vue'
//----------------------------------------------------------------

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'Login',
		component: Login,
	}, {
		path: '/Main',
		name: 'Main',
		component: Main,
		children: [{
			path: '/Home',
			name: 'Home',
			component: Home,
		},
		// 员工档案管理
		{
			path: '/HtmbGl',
			name: 'HtmbGl',
			component: HtmbGl,
		}, {
			path: '/HtmbSh',
			name: 'HtmbSh',
			component: HtmbSh,
		}, {
			path: '/HtqdFq',
			name: 'HtqdFq',
			component: HtqdFq,
		}, {
			path: '/Htqd',
			name: 'Htqd',
			component: Htqd,
		}, {
			path: '/Htgd',
			name: 'Htgd',
			component: Htgd,
		}, {
			path: '/Ygdaxx',
			name: 'Ygdaxx',
			component: Ygdaxx,
		}, {
			path: '/Jfmtgl',
			name: 'Jfmtgl',
			component: Jfmtgl,
		}, {
			path: '/Xmht',
			name: 'Xmht',
			component: Xmht,
		},
		// 集团组织架构管理
		{
			path: '/Jtzzjg',
			name: 'Jtzzjg',
			component: Jtzzjg,
		},
		{
			path: '/Ygxxlb',
			name: 'Ygxxlb',
			component: Ygxxlb,
		},
		{
			path: '/Ygrz',
			name: 'Ygrz',
			component: Ygrz,
		},
		{
			path: '/Yghtqd',
			name: 'Yghtqd',
			component: Yghtqd,
		},
		{
			path: '/Ygzz',
			name: 'Ygzz',
			component: Ygzz,
		},
		{
			path: '/Yglz',
			name: 'Yglz',
			component: Yglz,
		},
		{
			path: '/Ygtg',
			name: 'Ygtg',
			component: Ygtg,
		},
		{
			path: '/Hmdgl',
			name: 'Hmdgl',
			component: Hmdgl,
		},
		{
			path: '/Wcsq',
			name: 'Wcsq',
			component: Wcsq,
		},
		{
			path: '/Qjsq',
			name: 'Qjsq',
			component: Qjsq,
		},
		{
			path: '/Ccsq',
			name: 'Ccsq',
			component: Ccsq,
		},
		{
			path: '/Bksq',
			name: 'Bksq',
			component: Bksq,
		},
		{
			path: '/Jbsq',
			name: 'Jbsq',
			component: Jbsq,
		},
		{
			path: '/Gwzysq',
			name: 'Gwzysq',
			component: Gwzysq,
		},
		{
			path: '/Gwzy',
			name: 'Gwzy',
			component: Gwzy,
		},
		{
			path: '/Gwzyjs',
			name: 'Gwzyjs',
			component: Gwzyjs,
		},
		{
			path: '/Dgsq',
			name: 'Dgsq',
			component: Dgsq,
		}, {
			path: '/Jcgl',
			name: 'Jcgl',
			component: Jcgl,
		}, {
			path: '/Zttx',
			name: 'Zttx',
			component: Zttx,
		}, {
			path: '/QAsp',
			name: 'QAsp',
			component: QAsp,
		}, {
			path: '/Bxjsgl',
			name: 'Bxjsgl',
			component: Bxjsgl,
		},
		// 保险管理
		{
			path: '/Gzxgl',
			name: 'Gzxgl',
			component: Gzxgl,
		}, {
			path: '/Gzxbfgl',
			name: 'Gzxbfgl',
			component: Gzxbfgl,
		}, {
			path: '/Gzxcx',
			name: 'Gzxcx',
			component: Gzxcx,
		}, {
			path: '/Qtxzgl',
			name: 'Qtxzgl',
			component: Qtxzgl,
		}, {
			path: '/Qtxzcx',
			name: 'Qtxzcx',
			component: Qtxzcx,
		}, {
			path: '/Unpaid',
			name: 'Unpaid',
			component: Unpaid,
		},
		//智能排班
		{
			path: '/KqzGl',
			name: 'KqzGl',
			component: KqzGl,
		}, {
			path: '/QyxmGl',
			name: 'QyxmGl',
			component: QyxmGl,
		}, {
			path: '/YdgzrSd',
			name: 'YdgzrSd',
			component: YdgzrSd,
		}, {
			path: '/ZnPb',
			name: 'ZnPb',
			component: ZnPb,
		},
		//考勤管理
		{
			path: '/KqHz',
			name: 'KqHz',
			component: KqHz,
		},
		{
			path: '/dkmx',
			name: 'dkmx',
			component: dkmx,
		},
		{
			path: '/dkzp',
			name: 'dkzp',
			component: dkzp,
		},
		// 行政管理
		{
			path: '/SsfjGl',
			name: 'SsfjGl',
			component: SsfjGl,
		}, {
			path: '/SsrzGl',
			name: 'SsrzGl',
			component: SsrzGl,
		}, {
			path: '/SstzGl',
			name: 'SstzGl',
			component: SstzGl,
		}, {
			path: '/WpGl',
			name: 'WpGl',
			component: WpGl,
		}, {
			path: '/WpjcGl',
			name: 'WpjcGl',
			component: WpjcGl,
		}, {
			path: '/WpghGl',
			name: 'WpghGl',
			component: WpghGl,
		}, {
			path: '/WpzhCx',
			name: 'WpzhCx',
			component: WpzhCx,
		},
		//工资核算管理
		{
			path: '/GzMx',
			name: 'GzMx',
			component: GzMx,
		}, {
			path: '/GzmxBc',
			name: 'GzmxBc',
			component: GzmxBc,
		}, {
			path: '/GzZb',
			name: 'GzZb',
			component: GzZb,
		}, {
			path: '/GzHz',
			name: 'GzHz',
			component: GzHz,
		}, {
			path: '/GzffHz',
			name: 'GzffHz',
			component: GzffHz,
		}, {
			path: '/GzcfHz',
			name: 'GzcfHz',
			component: GzcfHz,
		}, {
			path: '/GzcfMx',
			name: 'GzcfMx',
			component: GzcfMx,
		}, {
			path: '/FfblSz',
			name: 'FfblSz',
			component: FfblSz,
		}, {
			path: '/Jsfs',
			name: 'Jsfs',
			component: Jsfs,
		},
		//投标管理
		{
			path: '/Bond',
			name: 'Bond',
			component: Bond,
		},
		{
			path: '/Performance',
			name: 'Performance',
			component: Performance,
		},
		{
			path: '/Gather',
			name: 'Gather',
			component: Gather,
		},
		{
			path: '/Agreement',
			name: 'Agreement',
			component: Agreement,
		},
		{
			path: '/Receivable',
			name: 'Receivable',
			component: Receivable,
		},
		{
			path: '/Collection',
			name: 'Collection',
			component: Collection,
		},
		{
			path: '/Invoicebill',
			name: 'Invoicebill',
			component: Invoicebill,
		},
		{
			path: '/DetailspartyA',
			name: 'DetailspartyA',
			component: DetailspartyA,
		},
		{
			path: '/DetailsparB',
			name: 'DetailsparB',
			component: DetailsparB,
		},
		{
			path: '/Collectiondata',
			name: 'Collectiondata',
			component: Collectiondata,
		},
		{
			path: '/Cleaning',
			name: 'Cleaning',
			component: Cleaning,
		},
		{
			path: '/Securitystaff',
			name: 'Securitystaff',
			component: Securitystaff,
		},

		//预算管理
		{
			path: '/Budgeting',
			name: 'Budgeting',
			component: Budgeting,
		},
		{
			path: '/Summary',
			name: 'Summary',
			component: Summary,
		},
		{
			path: '/Budmanagement',
			name: 'Budmanagement',
			component: Budmanagement,
		},
		{
			path: '/Implementation',
			name: 'Implementation',
			component: Implementation,
		},
		{
			path: '/Budsplitting',
			name: 'Budsplitting',
			component: Budsplitting,
		},
		{
			path: '/Mobilization',
			name: 'Mobilization',
			component: Mobilization,
		},

		// OA
		{
			path: '/approve',
			name: 'approve',
			component: approve,
		},
		{
			path: '/set',
			name: 'set',
			component: set,
		},
		// 数据字典
		{
			path: '/first_degree',
			name: 'first_degree',
			component: first_degree,
		}, {
			path: '/second_degree',
			name: 'second_degree',
			component: second_degree,
		}, {
			path: '/entry_type',
			name: 'entry_type',
			component: entry_type,
		}, {
			path: '/recruitment_method',
			name: 'recruitment_method',
			component: recruitment_method,
		}, {
			path: '/health',
			name: 'health',
			component: health,
		}, {
			path: '/household_register',
			name: 'household_register',
			component: household_register,
		}, {
			path: '/staff_type',
			name: 'staff_type',
			component: staff_type,
		}, {
			path: '/insurance_type',
			name: 'insurance_type',
			component: insurance_type,
		}, {
			path: '/underwriting_type',
			name: 'underwriting_type',
			component: underwriting_type,
		}, {
			path: '/room_type',
			name: 'room_type',
			component: room_type,
		}, {
			path: '/article_type',
			name: 'article_type',
			component: article_type,
		}, {
			path: '/province',
			name: 'province',
			component: province,
		}, {
			path: '/cities',
			name: 'cities',
			component: cities,
		}, {
			path: '/bank',
			name: 'bank',
			component: bank,
		}, {
			path: '/resignation_reason',
			name: 'resignation_reason',
			component: resignation_reason,
		}, {
			path: '/leave_type',
			name: 'leave_type',
			component: leave_type,
		}, {
			path: '/errand_type',
			name: 'errand_type',
			component: errand_type,
		}, {
			path: '/contract_type',
			name: 'contract_type',
			component: contract_type,
		}, {
			path: '/bonus_penalty',
			name: 'bonus_penalty',
			component: bonus_penalty,
		}, {
			path: '/change_salary',
			name: 'change_salary',
			component: change_salary,
		}, {
			path: '/age_group',
			name: 'age_group',
			component: age_group,
		}, {
			path: '/traffic_vehicle',
			name: 'traffic_vehicle',
			component: traffic_vehicle,
		}, {
			path: '/agency_company',
			name: 'agency_company',
			component: agency_company,
		}, {
			path: '/split_account',
			name: 'split_account',
			component: split_account,
		}, {
			path: '/business_sector',
			name: 'business_sector',
			component: business_sector,
		}, {
			path: '/business_series',
			name: 'business_series',
			component: business_series,
		}, {
			path: '/material',
			name: 'material',
			component: material,
		}, {
			path: '/fixedassets',
			name: 'fixedassets',
			component: fixedassets,
		}, {
			path: '/integration',
			name: 'integration',
			component: integration,
		},

		// 系统管理
		{
			path: '/user',
			name: 'user',
			component: user,
		}, {
			path: '/role',
			name: 'role',
			component: role,
		}, {
			path: '/post',
			name: 'post',
			component: post,
		}, {
			path: '/flow',
			name: 'flow',
			component: flow,
		},
		{
			path: '/setter',
			name: 'setter',
			component: setter,
		},
		//报表中心entry_exit
		{
			path: '/entry_exit',
			name: 'entry_exit',
			component: entry_exit,
		},
		{
			path: '/employee_info',
			name: 'employee_info',
			component: employee_info,
		},
		{
			path: '/five_insurances_statistical',
			name: 'five_insurances_statistical',
			component: five_insurances_statistical,
		},
		{
			path: '/five_insurances_detailed',
			name: 'five_insurances_detailed',
			component: five_insurances_detailed,
		},
		{
			path: '/employer_insurance',
			name: 'employer_insurance',
			component: employer_insurance,
		},
		{
			path: '/electric_vehicle_insurance',
			name: 'electric_vehicle_insurance',
			component: electric_vehicle_insurance,
		},
		{
			path: '/project_address_book',
			name: 'project_address_book',
			component: project_address_book,
		},
		{
			path: '/project_natural_conditions',
			name: 'project_natural_conditions',
			component: project_natural_conditions,
		},
		{
			path: '/project_assessment',
			name: 'project_assessment',
			component: project_assessment,
		},
		{
			path: '/big_ranking',
			name: 'big_ranking',
			component: big_ranking,
		},
		{
			path: '/employer_insurance_statistical',
			name: 'employer_insurance_statistical',
			component: employer_insurance_statistical,
		},
		{
			path: '/budget_comparison_table',
			name: 'budget_comparison_table',
			component: budget_comparison_table,
		},
		]
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js